<template>
    <div class="page-container">
        <div class="status-section">
            <div class="status-text">
                <span class="indicator-bar"></span>
                <span>
                    {{ orderDetail.deliveryType === 1 ? '门店自提' : '快递发货' }}
                </span>
            </div>
            <div class="delivery-toggle">
                <div class="toggle-item" :class="{ active: orderDetail.deliveryType === 1 }">
                    门店自提
                </div>
                <div class="toggle-item" :class="{ active: orderDetail.deliveryType === 2 }">
                    快递发货
                </div>
            </div>
        </div>
        <div class="scroll-content">
            <!-- 客户信息卡片 -->
            <div class="info-card customer-card">
                <div class="card-row header-row">
                    <div class="buyer-name">
                        买家姓名：{{ orderDetail.buyerName }}
                    </div>
                    <button class="contact-btn" @click="callPhone(orderDetail.buyerPhone)">
                        <span class="icon">
                            <img :src="phoneIco" alt="联系客户图标" />
                        </span> 联系客户
                    </button>
                </div>
                <div class="card-row">
                    买家手机号：{{ orderDetail.buyerPhone }}
                </div>
                <div class="card-row address-row">
                    <span class="label">收货地址：</span>
                    <span class="value">{{ orderDetail.address }}</span>
                </div>
            </div>

            <!-- 商品卡片 -->
            <div class="info-card product-card">
                <div class="product-content" v-for="(item, index) in orderDetail.productList" :key="index">
                    <img :src="item.productImage" class="product-img" alt="商品图片" />
                    <div class="product-info">
                        <div class="p_name_con">
                            <div class="p-title">{{ item.productName }}</div>
                            <span class="count">x{{ item.quantity }}</span>
                        </div>
                        <div class="p_specs_con">
                            <span>规格：{{ item.specs }}</span>
                            <span>¥{{ item.unitPrice }}</span>
                        </div>
                        <div class="p_price_con">
                            <span>赠送9积分</span>
                            <div class="line"></div>
                            <span>抵扣3积分</span>
                        </div>
                        <div class="p-price-row">
                            ¥{{ item.unitPrice }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- 订单基础信息 -->
            <div class="info-card base-info-card">
                <div class="info-line">
                    <span class="label">订单编号：</span>
                    <span class="value">{{ orderDetail.orderNo }}</span>
                    <button class="copy-btn" @click="copyText(orderDetail.orderNo)">复制</button>
                </div>
                <div class="info-line">
                    <span class="label">下单时间：</span>
                    <span class="value">{{ orderDetail.createTime }}</span>
                </div>
                <div class="info-line">
                    <span class="label">订单备注：</span>
                    <span class="value">{{ orderDetail.remark || '- -' }}</span>
                </div>
            </div>
            <!-- 优惠券/积分 -->
            <div class="info-card coupon-card-container">
                <div class="coupon-card">
                    <div class="left_title">
                        <img src="/src/assets/img/icons/icon50.png" class="icon_points" mode="aspectFill" />
                        <span class="points">优惠券</span>
                    </div>
                    <div class="right_coupon">
                        <span>优惠券名称</span>
                    </div>
                </div>
                <div class="coupon-card">
                    <div class="left_title">
                        <span class="points">积分抵现</span>
                    </div>
                    <div class="right_coupon">
                        <span>10分 共抵扣0.1元</span>
                    </div>
                </div>
            </div>
            <!-- 价格明细 -->
            <div class="info-card price-card">
                <div class="price-line">
                    <span>商品金额</span>
                    <span class="amount">¥{{ orderDetail.goodsTotal }}</span>
                </div>
                <div class="price-line">
                    <span>运 费</span>
                    <span class="amount">¥{{ orderDetail.freight }}</span>
                </div>
                <div class="total-line">
                    订单金额：<span class="big-price">¥{{ orderDetail.totalAmount }}</span>
                </div>
            </div>
            <div class="info-card scroll-card">
                <div class="left">
                    <img src="/src/assets/img/icons/icon51.png" class="icon_points" mode="aspectFill" />
                    <span>累计赠送积分</span>
                </div>
                <span>1000分</span>
            </div>
             <!-- 退款状态显示申请时间，退款成功显示退款时间 -->
            <view class="info-card scroll-card">
                <view class="left">
                    <text>申请时间</text>
                </view>
                <text>2025-03-26 11:00:00</text>
            </view>
            <view class="info-card pay_qrcod">
                <img src="/src/assets/img/checkin_tip.png" class="qrcode_img" mode="aspectFill" />
                <text>请客户使用微信/支付宝扫码支付</text>
            </view>
        </div>

        <div class="bottom-action-bar">
            <button class="btn btn-default">退单退款</button>
            <button class="btn btn-primary">直接发货</button>
        </div>

        <div class="safe-area-placeholder"></div>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { showToast } from 'vant';
import phoneIco from '@/assets/img/icons/phoneicon.png';

const orderDetail = reactive(
    {
        productList: [
            {
                productName: '商品名称',
                productImage: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80',
                specs: '100ml',
                unitPrice: '129.9',
                quantity: 1,
            },
            {
                productName: '商品名称',
                productImage: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80',
                specs: '100ml',
                unitPrice: '129.9',
                quantity: 1,
            },
        ],
        orderStatus: 1,//1=待付款，2=待发货，3=待收货，4=已完成，5=已取消,6=已退款
        orderNo: '219293811',
        createTime: '2025-03-26 11:00:00',
        buyerName: '张三',
        buyerPhone: '17293749276',
        address: '上海市杨浦区国定东路234号',
        goodsTotal: '129.9',
        points: '2',
        freight: '10',
        totalAmount: '149.9',
        remark: '请在配送时间前联系买家',
        deliveryType: 1,//1=快递，2=到店自提
    }
);

// --- 方法 ---
const copyText = (text) => {
    // 创建临时输入元素
    const tempInput = document.createElement('input');
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    showToast('复制成功');
    console.log('复制成功:', text);
    // alert('复制成功');
};
const callPhone = (phoneNumber) => {
    // 调用系统拨打电话功能
    window.location.href = `tel:${phoneNumber}`;
};
onMounted(() => {
    // 从 URL 查询参数中获取订单 ID
    const orderId = Number(useRoute().query.id);
    if (orderId) {
        // 调用后端接口获取订单详情
        // getOrderDetail(orderId).then((res) => {
        //   if (res.code === 200) {
        //     // 成功获取订单详情，更新订单详情数据
        //     Object.assign(orderDetail, res.data);
        //   } else {
        //     // 处理获取订单详情失败的情况
        //     console.error('获取订单详情失败:', res.msg);
        //   }
        // });
    }
});
</script>

<style lang="less" scoped>
.page-container {
    background-color: #f5f6fa;
    /* 背景灰 */
    min-height: 100vh;
    font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", Arial, sans-serif;
    color: #333333;
    padding-bottom: 80px;
}

// 1. 状态区域
.status-section {
    background-color: rgba(220, 187, 137, 0.15);
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .status-text {
        display: flex;
        align-items: center;
        font-size: 17px;
        font-weight: 600;
        color: #3C211F;

        .indicator-bar {
            width: 4px;
            height: 17px;
            background-color: #DCBB89;
            margin-right: 8px;
            border-radius: 2px;
        }
    }

    .delivery-toggle {
        display: flex;
        border: 1px solid #e6dace;
        border-radius: 2px;
        overflow: hidden;

        .toggle-item {
            padding: 6px 12px;
            font-size: 13px;
            color: #DCBB89;
            cursor: pointer;
            transition: all 0.2s;

            &.active {
                background-color: #DCBB89;
                color: #ffffff;
            }
        }
    }
}

// 2. 通用卡片样式
.scroll-content {
    padding: 10px;
}

.info-card {
    background: #ffffff;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 10px;
    font-size: 14px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.scroll-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    color: #333;

    .left {
        display: flex;
        align-items: center;

        .icon_points {
            width: 23px;
            height: 23px;
            margin-right: 5px;
        }
    }
}
.pay_qrcod{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 19px;
    color: #333;
    font-weight: bold;
    .qrcode_img{
        width: 150px;
        height: 150px;
        margin-bottom: 10px;
    }
}

.coupon-card-container {
    .coupon-card {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 13px;

        &:last-child {
            margin-bottom: 0;
        }

        .left_title {
            display: flex;
            align-items: center;

            .icon_points {
                width: 27px;
                height: 27px;
                margin-right: 4px;
            }

            .points {
                font-size: 15px;
                color: #666;
            }
        }

        .right_coupon {
            display: flex;
            align-items: center;
            font-size: 15px;
            color: #333;

            .icon_coupon {
                width: 13px;
                height: 13px;
                margin-top: 1px;
                margin-left: 13px;
            }
        }
    }
}

// 客户信息卡片
.customer-card {
    .card-row {
        margin-bottom: 8px;
        line-height: 1.5;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .header-row {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        .buyer-name {
            font-size: 15px;
            font-weight: 400;
            display: flex;
            align-items: center;
        }

        .contact-btn {
            border: 1px solid #FF7123;
            background: #ffffff;
            color: #FF7123;
            padding: 4px 10px;
            border-radius: 4px;
            font-size: 13px;
            display: flex;
            align-items: center;
            margin-bottom: -8px;

            .icon {
                margin-right: 4px;
                width: 19px;
                height: 19px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .address-row {
        display: flex;

        .label {
            white-space: nowrap;
            color: #333;
        }

        .value {
            color: #333333;
        }
    }
}

// 商品卡片
.product-card {
    .product-content {
        display: flex;

        &:not(:last-child) {
            border-bottom: 1px solid #f5f5f5;
            padding-bottom: 12px;
            margin-bottom: 12px;
        }

        .product-img {
            width: 80px;
            height: 80px;
            border-radius: 6px;
            object-fit: cover;
            margin-right: 12px;
            background-color: #eeeeee;
        }

        .product-info {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .p_name_con {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .p-title {
                    font-size: 15px;
                    color: #333333;
                    font-weight: 500;
                }

                .count {
                    color: #999999;
                    font-size: 14px;
                }
            }

            .p_specs_con {
                display: flex;
                align-items: center;
                justify-content: space-between;
                color: #999999;
                font-size: 12px;
            }

            .p_price_con {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                color: #FF7123;
                font-size: 13px;

                .line {
                    width: 1px;
                    height: 13px;
                    background-color: #FF7123;
                    margin: 0 8px;
                }
            }

            .p-price-row {
                display: flex;
                justify-content: flex-end;
                align-items: flex-end;
                color: #FF7123;
                font-size: 19px;
            }
        }
    }
}

// 基础信息卡片 (订单号等)
.base-info-card {
    .info-line {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        &:last-child {
            margin-bottom: 0;
        }

        .label {
            color: #666666;
            margin-right: 5px;
        }

        .value {
            color: #333333;
            font-family: monospace;
            font-size: 14px;
        }

        .copy-btn {
            margin-left: 10px;
            background: #ffffff;
            border: 1px solid #cccccc;
            color: #666666;
            font-size: 11px;
            padding: 1px 6px;
            border-radius: 2px;
        }
    }
}

// 价格明细卡片
.price-card {
    .price-line {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        color: #666666;

        .amount {
            color: #333333;
        }
    }

    .total-line {
        text-align: right;
        margin-top: 15px;
        border-top: 1px solid #f5f5f5;
        padding-top: 12px;
        font-size: 14px;
        font-weight: 600;

        .big-price {
            color: #FF7123;
            font-size: 15px;
            margin-left: 5px;
        }
    }
}

// 3. 底部操作栏
.bottom-action-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #ffffff;
    padding: 10px 15px;
    display: flex;
    justify-content: flex-end;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    z-index: 100;
    max-width: 450px;
    margin: 0 auto;

    .btn {
        height: 38px;
        padding: 0 20px;
        border-radius: 4px;
        font-size: 14px;
        margin-left: 10px;
        border: none;
        cursor: pointer;
    }

    .btn-default {
        background: #ffffff;
        border: 1px solid #dddddd;
        color: #666666;
    }

    .btn-primary {
        background: #cfaa71;
        /* 按钮金 */
        color: #ffffff;
    }
}

// 底部安全区 (适配 iPhone X 等)
.safe-area-placeholder {
    height: 20px;
    background: #ffffff;
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 99;
}

// 适配底部栏在iPhone上的位置
@supports (padding-bottom: env(safe-area-inset-bottom)) {
    .bottom-action-bar {
        padding-bottom: calc(10px + env(safe-area-inset-bottom));
    }

    .page-container {
        padding-bottom: calc(80px + env(safe-area-inset-bottom));
    }
}
</style>